import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { store } from './store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as config from './config';

Sentry.init({
  dsn: config.sentryDsn,
  environment: process.env.environment,
  integrations: [
    Sentry.browserTracingIntegration({}),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
